import React, {useRef, useEffect, useState, useContext, useTransition} from 'react';
import {FormContext} from "../../../context/FormContext";
import i18next from "i18next";
import {useTranslation} from "react-i18next";
import css from './checkbox.module.css';
import { LPEPrepCourseDateSelector } from './../../FormElements/LPEPrepCourseDateSelector/LPEPrepCourseDateSelector';


export const CheckBox = ({name, price, prettyName, descr, register, required,validate, setSendable}) => {

    const { addToPriceList , removeFromPriceList} = useContext(FormContext);
    const { t }  = useTranslation();
    const {formType} = useContext(FormContext);
    const { step1Content } = useContext(FormContext);

    const [isChecked,toggleChecked] = useState(false);
    const [selectedCourseDate,setSelectedDate] = useState('');
    const [sendCheckBox,setSendCheckBox] = useState(false);
    const [firstRender,setFirstRender] = useState(true);

    const isFirstRender = useRef(true);

useEffect(() => {
    // Voer de useEffect niet uit tijdens de eerste render
    if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
    }

    console.log("komt ie hier");

    // if (sendCheckBox) {
    //     setSendable(true);
    // } else {
    //     setSendable(false);
    // }
}, [sendCheckBox]);

    // Rehydrate state when navigating back to step 1
    useEffect(() => {
        const prevChecked = step1Content && step1Content[name];
        if (prevChecked === 'true' || prevChecked === true || prevChecked === 'on' || prevChecked === '1' || prevChecked === 1) {
            toggleChecked(true);
        }
        if (name === 'lpePrepCourse') {
            const prevDate = step1Content && step1Content['prep-course-date'];
            if (prevDate) {
                setSelectedDate(prevDate);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (name === "lpePrepCourse") {
            if (isChecked) {
                if (selectedCourseDate) {
                    setSendable(true);
                } else {
                    setSendable(false);
                }
            } else {
                setSendable(true);
            }
        }
    }, [selectedCourseDate, isChecked]);

    useEffect(() => {
        if (name === "lpePrepCourse") {
            if (isChecked && !selectedCourseDate) {
                setSendable(false);
            } else {
                setSendable(true);
            }
        }
        setFirstRender(false)
    }, [isChecked, selectedCourseDate]);

    useEffect(()=>{
        if (isChecked){
            addToPriceList(prettyName,price);
        }
        if (!isChecked){
            removeFromPriceList(prettyName);
        }



    },[isChecked])



    const inputChange = (e) => {
       const checked = e.target.checked;
       toggleChecked(checked);
       if (name === 'lpePrepCourse') {
           if (checked) {
               setSendable(!!selectedCourseDate);
           } else {
               setSendable(true);
           }
       }
    }


    return (
        <>
            <div className={css['input-field']}>
                <label htmlFor={name}>{prettyName}
                <p className={css['description']}>{descr}</p>
                <div className={css['label-checkbox-wrapper']}>
                   + Add {prettyName} <input type="checkbox"
                                            id={name}
                                            name={name}
                                            {...register(name)}
                                            checked={isChecked}
                                            onChange={(e)=>{ register(name).onChange(e); inputChange(e) }}
                />
                {name === 'lpePrepCourse' && isChecked && <LPEPrepCourseDateSelector     
                name='prep-course-date'
                register={register}
                required={required}
                validate={validate}
                setSelectedDate={setSelectedDate}
                selectedDate={selectedCourseDate}
                /> }
                </div>
                </label>
            </div>



        </>
    )
}


export default CheckBox;